(function () {
  var STYLE_ID = 'cart-og-frequency-style';
  var CSS =
    'select{background-color:#000;color:var(--color-grey-bone,#dedbd9)}' +
    'option{background-color:#000;color:var(--color-grey-bone,#dedbd9)}' +
    'option:checked,option:hover{background-color:var(--color-grey-shadow,#201e1d);color:#fff}';

  function inject(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    shadowRoot.appendChild(style);
  }

  function apply() {
    var container = document.getElementById('main-cart-items');
    if (!container) return;
    container
      .querySelectorAll('og-select-frequency')
      .forEach(function (frequency) {
        var ogSelect =
          frequency.shadowRoot &&
          frequency.shadowRoot.querySelector('og-select');
        inject(ogSelect && ogSelect.shadowRoot);
      });
  }

  function init() {
    var container = document.getElementById('main-cart-items');
    if (!container) return;

    apply();

    new MutationObserver(function () {
      apply();
      requestAnimationFrame(apply);
    }).observe(container, { childList: true, subtree: true, attributes: true });

    var tries = 0;
    var timer = setInterval(function () {
      apply();
      if (++tries > 16) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
